import watchPendency from './pendency'

export default watchPendency
